// Ultra-crisp vector Staunton Chess Pieces
// White pieces: Solid milk-white (#ffffff / #fffdf5) with bold crisp borders (#1c1917)
// Black pieces: Solid deep charcoal (#18181b / #27272a) with crisp light borders (#ffffff)

export const CHESS_SVG = {
  // White Pawn
  P: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg white-piece" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.5 9c-2.21 0-4 1.79-4 4 0 .89.29 1.71.78 2.38C17.33 16.5 16 18.59 16 21c0 2.03.94 3.84 2.41 5.03-3 1.06-7.41 5.55-7.41 13.47h23c0-7.92-4.41-12.41-7.41-13.47 1.47-1.19 2.41-3 2.41-5.03 0-2.41-1.33-4.5-3.28-5.62.49-.67.78-1.49.78-2.38 0-2.21-1.79-4-4-4z" fill="#ffffff" stroke="#18181b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,

  // White Knight
  N: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg white-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#ffffff" fill-rule="evenodd" stroke="#18181b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 10c10.5 1 16.5 8 16 29H15c0-9 10-6.5 8-21"/>
      <path d="M24 18c.38 2.91-5.55 7.37-8 9-3 2-2.82 4.34-5 4-1.042-.94 1.41-3.04 0-3-1 0 .19 1.23-1 2-1 0-4.003 1-4-4 0-2 6-12 6-12s1.89-1.9 2-3.5c-.73-.994-.5-2-.5-3 1-1 3 2.5 3 2.5h2s.78-1.992 2.5-3c1 0 1 3 1 3"/>
      <circle cx="9.5" cy="25.5" r="1" fill="#18181b"/>
      <circle cx="15" cy="15.5" r="1.2" fill="#18181b"/>
    </g>
  </svg>`,

  // White Bishop
  B: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg white-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#ffffff" fill-rule="evenodd" stroke="#18181b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 36c3.39-.97 10.11.43 13.5-2 3.39 2.43 10.11 1.03 13.5 2 0 0 1.65.54 3 2-.68.97-1.65.99-3 .5-3.39-.97-10.11.46-13.5-1-3.39 1.46-10.11.03-13.5 1-1.354.49-2.323.47-3-.5 1.354-1.94 3-2 3-2z"/>
      <path d="M15 32c2.5 2.5 12.5 2.5 15 0 .5-1.5 0-2 0-2 0-2.5-2.5-4-2.5-4 5.5-1.5 6-11.5-5-15.5-11 4-10.5 14-5 15.5 0 0-2.5 1.5-2.5 4 0 0-.5.5 0 2z"/>
      <path d="M25 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1 5 0z"/>
      <path d="M17.5 26h10M22.5 21v10" fill="none" stroke="#18181b" stroke-width="1.5"/>
    </g>
  </svg>`,

  // White Rook
  R: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg white-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#ffffff" fill-rule="evenodd" stroke="#18181b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 39h27v-3H9v3zm3-3v-4h21v4H12zm2-4h17l-1.5-15h-14L14 32zm-3-18h23v-5h-3v2h-4v-2h-5v2h-4v-2h-4v2h-3v-2z"/>
    </g>
  </svg>`,

  // White Queen
  Q: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg white-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#ffffff" fill-rule="evenodd" stroke="#18181b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M8 12a2 2 0 1 1-4 0 2 2 0 1 1 4 0zm16.5-4.5a2 2 0 1 1-4 0 2 2 0 1 1 4 0zM41 12a2 2 0 1 1-4 0 2 2 0 1 1 4 0zM14.5 10a2 2 0 1 1-4 0 2 2 0 1 1 4 0zm20 0a2 2 0 1 1-4 0 2 2 0 1 1 4 0z"/>
      <path d="M9 26c8.5-1.5 21-1.5 27 0l2-12-7 11-4-15-4.5 15-4.5-15-4 15-7-11 2 12zm0 6.5c9-.5 18-.5 27 0l.5-4.5c-9.5-.5-18.5-.5-28 0l.5 4.5zM9 39h27v-4H9v4z"/>
    </g>
  </svg>`,

  // White King
  K: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg white-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#ffffff" fill-rule="evenodd" stroke="#18181b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22.5 11.63V6M20 8h5" fill="none" stroke-width="2"/>
      <path d="M22.5 25s4.5-7.5 3-10.5c0 0-1-2.5-3-2.5s-3 2.5-3 2.5c-1.5 3 3 10.5 3 10.5"/>
      <path d="M11.5 37c5.5 3.5 15.5 3.5 21 0v-7s9-4.5 6-10.5c-4-1-6 2.5-6 2.5s-.5-1.5-2-2.5c-3-2-4.5-1-4.5-1s-1.5-3-4-3-4 3-4 3-1.5-1-4.5 1c-1.5 1-2 2.5-2 2.5s-2-3.5-6-2.5c-3 6 6 10.5 6 10.5v7z"/>
      <path d="M11.5 30c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0" fill="none"/>
    </g>
  </svg>`,

  // Black Pawn
  p: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg black-piece" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.5 9c-2.21 0-4 1.79-4 4 0 .89.29 1.71.78 2.38C17.33 16.5 16 18.59 16 21c0 2.03.94 3.84 2.41 5.03-3 1.06-7.41 5.55-7.41 13.47h23c0-7.92-4.41-12.41-7.41-13.47 1.47-1.19 2.41-3 2.41-5.03 0-2.41-1.33-4.5-3.28-5.62.49-.67.78-1.49.78-2.38 0-2.21-1.79-4-4-4z" fill="#18181b" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,

  // Black Knight
  n: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg black-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#18181b" fill-rule="evenodd" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 10c10.5 1 16.5 8 16 29H15c0-9 10-6.5 8-21"/>
      <path d="M24 18c.38 2.91-5.55 7.37-8 9-3 2-2.82 4.34-5 4-1.042-.94 1.41-3.04 0-3-1 0 .19 1.23-1 2-1 0-4.003 1-4-4 0-2 6-12 6-12s1.89-1.9 2-3.5c-.73-.994-.5-2-.5-3 1-1 3 2.5 3 2.5h2s.78-1.992 2.5-3c1 0 1 3 1 3"/>
      <circle cx="9.5" cy="25.5" r="1.2" fill="#ffffff"/>
      <circle cx="15" cy="15.5" r="1.3" fill="#ffffff"/>
    </g>
  </svg>`,

  // Black Bishop
  b: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg black-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#18181b" fill-rule="evenodd" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 36c3.39-.97 10.11.43 13.5-2 3.39 2.43 10.11 1.03 13.5 2 0 0 1.65.54 3 2-.68.97-1.65.99-3 .5-3.39-.97-10.11.46-13.5-1-3.39 1.46-10.11.03-13.5 1-1.354.49-2.323.47-3-.5 1.354-1.94 3-2 3-2z"/>
      <path d="M15 32c2.5 2.5 12.5 2.5 15 0 .5-1.5 0-2 0-2 0-2.5-2.5-4-2.5-4 5.5-1.5 6-11.5-5-15.5-11 4-10.5 14-5 15.5 0 0-2.5 1.5-2.5 4 0 0-.5.5 0 2z"/>
      <path d="M25 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1 5 0z"/>
      <path d="M17.5 26h10M22.5 21v10" fill="none" stroke="#ffffff" stroke-width="1.4"/>
    </g>
  </svg>`,

  // Black Rook
  r: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg black-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#18181b" fill-rule="evenodd" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 39h27v-3H9v3zm3-3v-4h21v4H12zm2-4h17l-1.5-15h-14L14 32zm-3-18h23v-5h-3v2h-4v-2h-5v2h-4v-2h-4v2h-3v-2z"/>
    </g>
  </svg>`,

  // Black Queen
  q: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg black-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#18181b" fill-rule="evenodd" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
      <path d="M8 12a2 2 0 1 1-4 0 2 2 0 1 1 4 0zm16.5-4.5a2 2 0 1 1-4 0 2 2 0 1 1 4 0zM41 12a2 2 0 1 1-4 0 2 2 0 1 1 4 0zM14.5 10a2 2 0 1 1-4 0 2 2 0 1 1 4 0zm20 0a2 2 0 1 1-4 0 2 2 0 1 1 4 0z"/>
      <path d="M9 26c8.5-1.5 21-1.5 27 0l2-12-7 11-4-15-4.5 15-4.5-15-4 15-7-11 2 12zm0 6.5c9-.5 18-.5 27 0l.5-4.5c-9.5-.5-18.5-.5-28 0l.5 4.5zM9 39h27v-4H9v4z"/>
    </g>
  </svg>`,

  // Black King
  k: `<svg viewBox="0 0 45 45" width="100%" height="100%" class="chess-svg black-piece" xmlns="http://www.w3.org/2000/svg">
    <g fill="#18181b" fill-rule="evenodd" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22.5 11.63V6M20 8h5" fill="none" stroke="#ffffff" stroke-width="2"/>
      <path d="M22.5 25s4.5-7.5 3-10.5c0 0-1-2.5-3-2.5s-3 2.5-3 2.5c-1.5 3 3 10.5 3 10.5"/>
      <path d="M11.5 37c5.5 3.5 15.5 3.5 21 0v-7s9-4.5 6-10.5c-4-1-6 2.5-6 2.5s-.5-1.5-2-2.5c-3-2-4.5-1-4.5-1s-1.5-3-4-3-4 3-4 3-1.5-1-4.5 1c-1.5 1-2 2.5-2 2.5s-2-3.5-6-2.5c-3 6 6 10.5 6 10.5v7z"/>
      <path d="M11.5 30c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0" fill="none" stroke="#ffffff"/>
    </g>
  </svg>`
};
